import {
  Avatar,
  IconButton,
  Divider,
  TextField,
  Typography,
  Button,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { Box } from "@mui/system";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { singleUser, updateUser } from "../../../states/actions/userAction";
import BaseUrl from "../../../service/API/base_url";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";

const Profile = () => {
  // use form
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  const Role = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;

  function parseJWT(token) {
    if (Role !== null) {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    }
  }
  const userInfo = parseJWT(Role);

  const users = useSelector((state) => state.users);

  useEffect(() => {
    onReset();
  }, []);
  const onReset = async () => {
    if (userInfo !== null || userInfo !== undefined) {
      const result = await dispatch(singleUser(userInfo.id));

      reset(result.payload);
    }
  };

  const [picture, setPicture] = useState(null);
  const [getImg, setImg] = useState(null);
  const [imageGallery1, setImageGallery] = useState();
  const fileInputRef = useRef();
  const handleEditClick = () => {
    fileInputRef.current.click(); // 👈 programmatically click the hidden file input
  };

  const onImageUpload = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setPicture(URL.createObjectURL(file));
      setImg(file);
    }
  };

  useEffect(() => {
    if (users?.users?.length !== null && users?.users !== undefined) {
      setImageGallery(users?.users?.photo1);
    }
  }, [users?.users]);

  const onSubmit = (userData) => {
    userData.photo1 = getImg;
    const formData = new FormData();
    Object?.entries(userData).map((entry) => {
      const [key, value] = entry;
      formData.append(key, value);
    });
    // dispatch
    dispatch(updateUser({ formData: formData, id: userInfo.id }));
  };
  const { t: translate } = useTranslation(["setting"]);
  return (
    <Box>
      <ToastContainer />
      <Typography variant="subtitle1">{translate("Profile")}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.8, pb: 2 }}>
        {translate("Update your photo")}
      </Typography>
      <Divider />
      <Box sx={{ mt: 3 }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Typography variant="subtitle1">
            {translate("Profile image")}
          </Typography>
          {/* <Avatar src="/images/avatars/dr-tesfaye.jpg" /> */}
          <Box sx={{ position: "relative", display: "inline-block" }}>
            {getImg ? (
              <Avatar src={picture} sx={{ width: 80, height: 80 }} />
            ) : (
              <Avatar
                src={`${BaseUrl}${imageGallery1}`}
                sx={{ width: 80, height: 80 }}
              />
            )}

            <IconButton
              size="small"
              sx={{
                position: "absolute",
                bottom: 0,
                right: 0,
                backgroundColor: "background.paper",
                boxShadow: 1,
                "&:hover": { backgroundColor: "primary.light" },
              }}
              onClick={handleEditClick} // ✅ correctly triggers input click
            >
              <EditIcon fontSize="small" />
            </IconButton>

            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              onChange={onImageUpload} // ✅ handles file selection
              style={{ display: "none" }}
            />
          </Box>

          <Box sx={{ mt: 4, display: "flex", alignItems: "center", gap: 4 }}>
            <TextField
              //label="First Name"
              placeholder="Enter first name"
              variant="outlined"
              rows={4}
              fullWidth
              size="small"
              {...register(`firstName`, {
                required: true,
                maxLength: 100,
              })}
            />
            <TextField
              // label="Last Name"
              placeholder="Enter last name"
              variant="outlined"
              rows={4}
              fullWidth
              size="small"
              {...register(`lastName`, {
                required: true,
                maxLength: 100,
              })}
            />
          </Box>
          <Box sx={{ mt: 4, display: "flex", alignItems: "center", gap: 4 }}>
            <TextField
              // label="Email"
              placeholder="test@gmail.com"
              variant="outlined"
              size="small"
              fullWidth
              {...register(`email`, {
                required: true,
                pattern:
                  /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
              })}
            />

            <TextField
              //  label={translate("Phone")}
              placeholder="Enter Phone No."
              variant="outlined"
              size="small"
              fullWidth
              {...register(`phone`, {
                required: true,
                maxLength: 100,
              })}
            />
          </Box>
          <Box sx={{ mt: 4 }}>
            <Button
              variant="contained"
              color="primary"
              sx={{ borderRadius: "5px" }}
              type="submit"
            >
              {translate("Submit")}
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  );
};

export default Profile;
